import React from 'react';
import { ReplaysListResponseType } from '../../../../lib/api';
import { DefaultCarouselView } from '../../../../lib/api/custom-page.types';
import { EventType } from '../../SessionWrapper/LayoutWrapper';
import ReplaysTrackItem from './ReplaysTrackItem';
import { useSessionsByTrack } from './useSessionsByTrack';
import '../ReplaysWrapper.scss';

interface IProps {
  sessions: ReplaysListResponseType | void;
  event: EventType;
  defaultCarouselView?: DefaultCarouselView;
}

const ReplaysSessionsByTrack = ({ sessions, event, defaultCarouselView }: IProps): JSX.Element | null => {
  const sessionsGroupedByTrack = useSessionsByTrack(sessions || []);

  return (
    <div className='meeting-card-grouped-track'>
      {sessionsGroupedByTrack.map(group => (
        <ReplaysTrackItem
          key={group.track || 'no-track'}
          track={group.track}
          featuredSessions={group.featuredSessions}
          sessions={group.sessions}
          event={event}
          defaultCarouselView={defaultCarouselView}
        />
      ))}
    </div>
  );
};

export default ReplaysSessionsByTrack;
